import { ApplicabilityReasons, ApplicabilityReasonsColor } from 'models/control';
import { NormCoverage } from 'models/dashboardScene';
import { EntityStatus, EntityStatusColor } from 'models/entityStatus';
import Tag from 'models/tag';
import { useTranslation } from 'react-i18next';
import { FluentUIPieChart, IPieChartDataPoint } from './PieChart';

interface CustomNormCoverageProps {
  CustomNormCoverageData: NormCoverage | undefined;
  tags?: Tag[];
  height?: number;
  width?: number;
}

const CustomNormCoverageChart = (props: CustomNormCoverageProps) => {
  const { t } = useTranslation(['translation', 'widgets']);

  const getLink = (series: number) => {
    if (!props.CustomNormCoverageData) return;

    return undefined;
  };

  const getData = (): IPieChartDataPoint[] => {
    if (!props.CustomNormCoverageData) return [];

    const data: IPieChartDataPoint[] = [
      {
        name: t('translation:EntityStatus.Todo'),
        value: props.CustomNormCoverageData.toDoCount,
        link: getLink(0),
        color: EntityStatusColor[EntityStatus.Todo],
      },
      {
        name: t('translation:EntityStatus.Designing'),
        value: props.CustomNormCoverageData.designingCount,
        link: getLink(1),
        color: EntityStatusColor[EntityStatus.Designing],
      },
      {
        name: t('translation:EntityStatus.Implementing'),
        value: props.CustomNormCoverageData.implementingCount,
        link: getLink(2),
        color: EntityStatusColor[EntityStatus.Implementing],
      },
      {
        name: t('translation:EntityStatus.Implemented'),
        value: props.CustomNormCoverageData.implementedCount,
        link: getLink(3),
        color: EntityStatusColor[EntityStatus.Implemented],
      },
      {
        name: t('widgets:CustomNormCoverage.OutOfScope'),
        value: props.CustomNormCoverageData.outOfScopeCount,
        link: getLink(4),
        color: ApplicabilityReasonsColor[ApplicabilityReasons.OutOfScope],
      },
    ];

    return data.filter((d) => d.value > 0);
  };

  //
  // Main render
  //
  return (
    <FluentUIPieChart
      height={props.height}
      width={props.width}
      data={getData()}
      label={props.CustomNormCoverageData?.controlCount.toString()}
    />
  );
};

export default CustomNormCoverageChart;
